import { AfterViewInit, Directive, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { timer } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { userAgent } from '../../misc/user-agent';
import { isPlatformBrowser } from '@angular/common';

@Directive({
    selector: '[appAutocompleteOff]'
})
export class AutocompleteOffDirective implements AfterViewInit {

    constructor(
        private el: ElementRef,
        @Inject(PLATFORM_ID) private platformId: object) {
    }
    ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId)) {
            const ua = userAgent();
            timer(1000).pipe(
                take(1),
                tap(() => {
                    this.el.nativeElement.setAttribute('autocomplete', (ua === 'chrome') ? 'none' : 'off');
                    this.el.nativeElement.setAttribute('autocorrect', 'off');
                    this.el.nativeElement.setAttribute('autocapitalize', 'none');
                    this.el.nativeElement.setAttribute('spellcheck', 'false');
                })
            ).subscribe();
        }
    }
}
